export enum LogLevel {
    Error = 'Error',
    Info = 'Info',
    Warn = 'Warn',
}
